import { useParams, Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];

  const jsonLd = currentCategory ? { '@context': 'https://schema.org', '@graph': [{ '@type': 'CollectionPage', name: `${currentCategory.name} - 庭院花园设计`, description: currentCategory.description, url: `https://tingyuanhuayuan.cn/category/${slug}`, isPartOf: { '@type': 'WebSite', name: '庭院花园' } }, { '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: '首页', item: 'https://tingyuanhuayuan.cn/' }, { '@type': 'ListItem', position: 2, name: currentCategory.name, item: `https://tingyuanhuayuan.cn/category/${slug}` }] }] } : null;

  return (
    <>
      <ScrollToTop />
      {jsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}
      <Navbar />
      <main className="pt-16 md:pt-[72px]">
        <Breadcrumb />
        <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50">
          <div className="max-w-[1280px] mx-auto">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">{currentCategory?.name || '分类页面'}</h1>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl leading-relaxed">{currentCategory?.description || ''}</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 py-6 bg-background-50 border-b border-background-200/70 sticky top-16 md:top-[72px] z-30 bg-background-50/95 backdrop-blur-md">
          <div className="max-w-[1280px] mx-auto overflow-x-auto">
            <div className="flex items-center gap-2 min-w-max">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${cat.slug === slug ? 'bg-primary-500 text-white' : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-700 border border-background-200/70'}`}>
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>{cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-[900px] mx-auto">
            {articles.length > 0 ? (
              <div className="flex flex-col gap-4 md:gap-5">
                {articles.map((article) => (
                  <Link key={article.id} to={`/article/${article.id}`} className="group flex flex-col sm:flex-row gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                    <div className="w-full sm:w-48 md:w-56 h-40 sm:h-36 flex-shrink-0 rounded-lg overflow-hidden">
                      <img src={article.heroImageUrl} alt={article.title} title={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                    </div>
                    <div className="flex-1 min-w-0 flex flex-col justify-center">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">{currentCategory?.name}</span>
                        <span className="text-xs text-foreground-400">{article.readTime}</span>
                      </div>
                      <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">{article.title}</h2>
                      <p className="mt-1.5 text-sm text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                      <div className="mt-3 flex items-center gap-1 flex-wrap">
                        {article.tags.map((tag) => (<span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded">#{tag}</span>))}
                      </div>
                      <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400"><span>{article.author}</span><span>·</span><span>{article.date}</span></div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200/70"><i className="ri-file-search-line text-2xl text-foreground-400"></i></div>
                <p className="text-foreground-500">该分类下暂无文章</p>
                <Link to="/" className="inline-block mt-3 text-sm text-primary-600 hover:text-primary-700">返回首页</Link>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}